module.exports = __webpack_public_path__ + "img/8.4d4bb526.png";